import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IRetryBillingResultEntity } from '../types';

export const retryBilling = async (): Promise<IRetryBillingResultEntity[]> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post<IRetryBillingResultEntity[]>(
    `/payment/user/office-plan/retry-billing`,
    {},
    { headers },
  );

  return response.data;
};
